import { useState } from "react";

export function useContextMenu() {
  const [anchor, setAnchor] = useState<undefined | Element>(undefined);
  const isMenuOpen = Boolean(anchor);
  const handleMenuOpen = (event: React.MouseEvent<Element>) => {
    setAnchor(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchor(undefined);
  };
  return { anchor, isMenuOpen, handleMenuOpen, handleMenuClose };
}
